export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9628.46e7c546.jpg";